// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_VclK4 {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background-color: var(--white-color);
  border-radius: 12px;
  box-shadow: 0 4px 12px var(--_0000001a-shadow);
  max-width: 280px;
  min-width: 200px;
  bottom: 25px;
  left: -55px;
  pointer-events: auto;
  cursor: pointer;

  >div {
    display: inline-flex;
    flex-direction: column;
    gap: 2px;
    margin-top: -6px;
  }
}

.avatar_nvhuX {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.name_FGH3I {
  font-weight: 600;
  margin: 0;
  color: #111;
}

.email_KjIYe {
  font-size: 14px;
  color: var(--_6-color);
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/MiniProfileModal/MiniProfileModal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;;EAEf;IACE,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".container {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px;\n  background-color: var(--white-color);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px var(--_0000001a-shadow);\n  max-width: 280px;\n  min-width: 200px;\n  bottom: 25px;\n  left: -55px;\n  pointer-events: auto;\n  cursor: pointer;\n\n  >div {\n    display: inline-flex;\n    flex-direction: column;\n    gap: 2px;\n    margin-top: -6px;\n  }\n}\n\n.avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.name {\n  font-weight: 600;\n  margin: 0;\n  color: #111;\n}\n\n.email {\n  font-size: 14px;\n  color: var(--_6-color);\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_VclK4`,
	"avatar": `avatar_nvhuX`,
	"name": `name_FGH3I`,
	"email": `email_KjIYe`
};
export default ___CSS_LOADER_EXPORT___;
